import {
	TFileId,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	ICustomerLanguageInfo,
	IMenuTranslation,
	IItemSubCategory,
	DirectionForPaginated,
	ITranslationInfo,
	EntityStatus,
} from 'types';

export type TCategoryType =
	| 'Default'
	| 'Hidden'
	| 'Game'
	| 'Lunch'
	| 'Takeaway'
	| 'AdditionalIngredients'
	| 'Alcohol'
	| 'Commission'
	| 'ComboItems'
	| 'ServiceCharge'
	| 'Charity'
	| 'Children';

export interface ICategoryTypes {
	categoryID: TCategoryType;
	categoryName: string;
}

export interface IRestaurantsCategories {
	id: string;
	restaurantName: Nullable<string>;
	positionNumber: number;
	categoryId: string;
}

interface IDefaultCategoryItem {
	id: string;
	name: string;
	categoryType: TCategoryType;
	customerId: string;
	customerName: string;
	// positionNumber: number;
	withAssignedDishes: boolean;
	filePath: Nullable<string>;
	// restaurantsCategories: [
	// 	{ restaurantId: string; restaurantName: string; categoryId: string },
	// 	...{ restaurantId: string; restaurantName: string; categoryId: string }[]
	// ];
	restaurantsCategories: IRestaurantsCategories[];
	isRestricted: boolean;
	activationCron: string | null;
	deactivationCron: string | null;
}

export interface ISubCategoriesForIItemCategory {
	id: string;
	subCategoryName: string;
}

export interface IItemCategory extends IDefaultCategoryItem {
	subCategories: ISubCategoriesForIItemCategory[];
}

// Menu v1
export interface ICategory {
	categoriesCount: number;
	categories: IItemCategory[];
}
// Menu v1
// Menu v2
export interface ICategoryV2 {
	totalCount: number;
	items: {
		id: string;
		name: Nullable<string>;
		type: TCategoryType;
		restaurants: IItemForGetShortInfo[];
		preSignedUrl?: Nullable<string>;
	}[];
}
// Menu v2

// Menu v1
interface IDataGetCategoryInfo extends IDefaultCategoryItem {
	preSignedUrl: Nullable<string>;
	subCategories: IItemSubCategory[];
	customer: ICustomerLanguageInfo | null;
	translations: IMenuTranslation[];
}

export interface IGetCategoryInfo {
	data: {
		category: IDataGetCategoryInfo;
	};
}
// Menu v1
// Menu v2
export interface IDataGetCategoryInfoV2 {
	id: string;
	name: Nullable<string>;
	customer: IItemForGetShortInfo;
	photoPath: Nullable<string>;
	type: TCategoryType;
	isRestricted: boolean;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
	overrideScheduleAvailability: boolean;
	restaurants: IItemForGetShortInfoWithStatus[];
	translations: ITranslationInfo[];
}

export interface IGetCategoryInfoV2 {
	data: IDataGetCategoryInfoV2;
}
// Menu v2

// Menu v1
export interface IGetPaginatedCategories {
	pageNumber: number;
	pageSize: number;
	searchByName: Nullable<string>;
	customerId: Nullable<string>;
	restaurantId: Nullable<string>;
	categoryTypes: TCategoryType[];
	sortByCategories: Nullable<string>;
	sortByCategoryType: Nullable<string>;
	sortByCustomer: Nullable<string>;
}
// Menu v1
// Menu v2
export enum SortByForPaginatedCategories {
	Name = 'Name',
	Type = 'Type',
}

export interface IGetPaginatedCategoriesV2 {
	customerId: string;
	restaurantId: Nullable<string>;
	pageNumber: number;
	pageSize: number;
	searchInput: Nullable<string>;
	types: TCategoryType[];
	sorting: Nullable<{
		sortBy: SortByForPaginatedCategories;
		direction: DirectionForPaginated;
	}>;
}
// Menu v2

// Menu v1
export interface ICreateCategory {
	name: string;
	categoryType: TCategoryType;
	customerId: string;
	fileId: TFileId;
	categoryRestaurantIds: string[];
	isRestricted: boolean;
	activationCron: string | null;
	deactivationCron: string | null;
	translations: IMenuTranslation[];
}
// Menu v1
// Menu v2
export interface ICreateCategoryV2 {
	name: string;
	customerId: string;
	type: TCategoryType;
	fileId: TFileId;
	restaurantIds: string[];
	isRestricted: boolean;
	overrideScheduleAvailability: boolean;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
	translations: IMenuTranslation[];
}
// Menu v2

// Menu v1
export interface IUpdateCategory {
	id: string;
	name: string;
	categoryType: TCategoryType;
	customerId: string;
	fileId: TFileId;
	categoryRestaurantIds: string[];
	isRestricted: boolean;
	activationCron: string | null;
	deactivationCron: string | null;
	translations: IMenuTranslation[];
}
// Menu v1
// Menu v2
export interface IUpdateCategoryV2 {
	id: string;
	name: Nullable<string>;
	type: TCategoryType;
	fileId: TFileId;
	isRestricted: boolean;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
	overrideScheduleAvailability: boolean;
	restaurantIds: string[];
	translations: IMenuTranslation[];
}
// Menu v2

export interface IGetCategoriesShort {
	restaurantIds: string[];
	type?: TCategoryType;
}

export interface IGetCategoriesByCustomerShort {
	customerId: string;
	type?: TCategoryType;
}

export interface IGetCategoriesShortResponse {
	data: {
		categories: IItemForGetShortInfo[]; // returning unique categories
	};
}

// Menu v1
export interface ICategoryPositionItem {
	id: string;
	name: string | null;
	positionNumber: number;
	filePath: string | null;
	categoryType: TCategoryType;
	customer: IItemForGetShortInfo;
	restaurants: IItemForGetShortInfo[];
}

export interface IGetCategoryPositionList {
	data: {
		categoryPositions: ICategoryPositionItem[];
	};
}
// Menu v1
// Menu v2
export interface ICategoryPositionItemV2 {
	id: string;
	name: string;
	type: TCategoryType;
	subCategories: IItemForGetShortInfo[];
	preSignedUrl?: Nullable<string>;
}

export interface IGetCategoryPositionListV2 {
	data: {
		categories: ICategoryPositionItemV2[];
	};
}
// Menu v2

export interface ICategoryPositionChain {
	id: string;
	name: string;
	address: string;
	status: EntityStatus;
}

export interface IGetCategoryPositionChains {
	data: {
		restaurants: ICategoryPositionChain[];
	};
}

export interface IUpdateCategoryPositions {
	restaurantIds: string[];
	categoryIds: string[];
}

export interface IGetCategoryRestaurantPropertiesArguments {
	restaurantId: string;
	categoryId: string;
}

export interface IGetCategoryRestaurantProperties {
	data: {
		id: string;
		name: Nullable<string>;
		customer: IItemForGetShortInfo;
		restaurantId: Nullable<string>;
		subCategories: {
			id: string;
			name: string;
		}[];
		activationCron: Nullable<string>;
		deactivationCron: Nullable<string>;
	};
}

export interface IUpdateCategoryRestaurantProperties {
	categoryId: string;
	restaurantId: string;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
}

export type TPropertiesOfPatchChangesForCategory = 'activation' | 'deactivation';
export interface IPropertiesOfPatchChangesForCategory {
	id: TPropertiesOfPatchChangesForCategory;
	name: TPropertiesOfPatchChangesForCategory;
}

export interface IUpdateRestaurantPropertiesAsPatchForCategory {
	categoryId: string;
	restaurantIds: string[];
	update: {
		activationCron: {
			shouldUpdate: boolean;
			value: string;
		};
		deactivationCron: {
			shouldUpdate: boolean;
			value: string;
		};
	};
}
